import { utagViewArtificialPageView } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import CartBaseItemView from '../../baseViews/ItemView';
import EmailCartLinkTemplate from '../templates/EmailCartLinkTemplate';

const trackArtificalPageViewEvent = utagViewArtificialPageView();

const EmailCartLink = CartBaseItemView.extend({
	JSXTemplate: EmailCartLinkTemplate,
	tagName: 'button',
	className: 'jsEmail anchorLink',
	attributes: {
		type: 'button',
		'aria-haspopup': 'true'
	},
	events: {
		click: 'displayEmailModal'
	},
	displayEmailModal (e) {

		e.preventDefault();

		$('body').lpModal({
			appendContentToForm: false,
			src: '/cart/emailcart/',
			lpModalClass: 'lpModal--alt1',
			onInit: true,
			width: 496,
			height: 464,
			closeEvt: () => trackArtificalPageViewEvent({ pageName: '' })
		});

		setGenericEvent({ event_name: 'cart_email_click' });

	}
});

export default EmailCartLink;
